import { ReservationRequestsComponent } from "./list-reservs-restaurant/list-reservs-restaraunt";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";

import { IonicModule } from "@ionic/angular";

import { CallPage } from "./call-driver/call.page";
import { ComponentsModule } from "../components/component.module";
import { HistoryRacesPage } from "./history-races/history-races.page";
import { BalanceDriverPage } from "./balance-driver/balance-driver.page";
import { DriverAcceptPage } from "./driver-accept/driver-accept.page";
import { SellerRegistrationPage } from "./seller-registration/seller-registration";
import { RestaurantBookingComponent } from "./restaurant-booking/restaurant.booking";
import { HistoryRestaurantsPage } from "./history-restaurants/history-restaurants.page";

import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { DashboardPage } from "./dashboard/dashboard.page";

import { QRCodeComponent } from "angularx-qrcode";
import { LazyLoadImageModule } from "ng-lazyload-image";
import { HistoryBrochuresPage } from "./history-brochures/history-brochures.page";
import { PointsWithdrawalComponent } from "./points-withdrawal/points-withdrawal.component";
import { ScheduledTripsPage } from "./scheduled-trips/scheduled-trips.page";
import { TripCheckoutPage } from "./trip-checkout/trip-checkout.page";
import { PaymentLinkSharePage } from "./payment-link-share/payment-link-share.page";
import { WithdrawalHistoryPage } from "./withdrawal-history/withdrawal-history.page";
import { VoucherPage } from "./voucher/voucher.page";
import { PayoutMethodsPage } from "./payout-methods/payout-methods.page";
const COMPONENTS = [
  CallPage,
  HistoryRacesPage,
  BalanceDriverPage,
  DriverAcceptPage,
  SellerRegistrationPage,
  RestaurantBookingComponent,
  ReservationRequestsComponent,
  HistoryRestaurantsPage,
  HistoryBrochuresPage,
  DashboardPage,
  PointsWithdrawalComponent,
  ScheduledTripsPage,
  TripCheckoutPage,
  PaymentLinkSharePage,
  WithdrawalHistoryPage,
  VoucherPage,
  PayoutMethodsPage,
];

const routes: Routes = [
  {
    path: "call-driver",
    component: CallPage,
  },
  {
    path: "call-driver/:vendedorId",
    component: CallPage,
  },
  {
    path: "history-races",
    component: HistoryRacesPage,
  },
  {
    path: "scheduled-trips",
    component: ScheduledTripsPage,
  },
  {
    path: "history-restaurants",
    component: HistoryRestaurantsPage,
  },
  {
    path: "history-restaurants/:id",
    component: HistoryRestaurantsPage,
  },
  {
    path: "history-brochures/:id",
    component: HistoryBrochuresPage,
  },
  {
    path: "history-brochures",
    component: HistoryBrochuresPage,
  },
  {
    path: "points-withdrawal",
    component: PointsWithdrawalComponent,
  },
  {
    path: "restaurants-booking",
    component: RestaurantBookingComponent,
  },
  {
    path: "restaurants-booking/:vendedorId",
    component: RestaurantBookingComponent,
  },
  {
    path: "restaurants-booking/:vendedorId/:isQrCode",
    component: RestaurantBookingComponent,
  },
  {
    path: "reservations-requests",
    component: ReservationRequestsComponent,
  },
  {
    path: "reservations-requests/:id",
    component: ReservationRequestsComponent,
  },
  {
    path: "balance-driver",
    component: BalanceDriverPage,
  },
  {
    path: "driver-accept",
    component: DriverAcceptPage,
  },
  {
    path: "seller-registration",
    component: SellerRegistrationPage,
  },
  {
    path: "dashboard",
    component: DashboardPage,
  },
  {
    path: "trip-checkout",
    component: TripCheckoutPage,
  },
  {
    path: "payment-link-share",
    component: PaymentLinkSharePage,
  },
  {
    path: "withdrawal-history",
    component: WithdrawalHistoryPage,
  },
  {
    path: "voucher/:corridaId",
    component: VoucherPage,
  },
  {
    path: "payout-methods",
    component: PayoutMethodsPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    IonicModule,
    MatDatepickerModule,
    MatNativeDateModule,
    RouterModule.forChild(routes),
    QRCodeComponent,
    LazyLoadImageModule,
  ],
  declarations: [...COMPONENTS],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CallPageModule { }
